export const FETCH_PARTNER_REQUEST = 'FETCH_PARTNER_REQUEST';
export const FETCH_PARTNER_SUCCESS = 'FETCH_PARTNER_SUCCESS';
export const FETCH_PARTNER_FAILURE = 'FETCH_PARTNER_FAILURE';

export const FETCH_ETABLISSEMENT_LIST_REQUEST = 'FETCH_ETABLISSEMENT_LIST_REQUEST';
export const FETCH_ETABLISSEMENT_LIST_SUCCESS = 'FETCH_ETABLISSEMENT_LIST_SUCCESS';
export const FETCH_ETABLISSEMENT_LIST_FAILURE = 'FETCH_ETABLISSEMENT_LIST_FAILURE';

export const FETCH_ETABLISSEMENT_REQUEST = 'FETCH_ETABLISSEMENT_REQUEST';
export const FETCH_ETABLISSEMENT_SUCCESS = 'FETCH_ETABLISSEMENT_SUCCESS';
export const FETCH_ETABLISSEMENT_FAILURE = 'FETCH_ETABLISSEMENT_FAILURE';

export const FETCH_ANTICIPA_REQUEST = 'FETCH_ANTICIPA_REQUEST';
export const FETCH_ANTICIPA_SUCCESS = 'FETCH_ANTICIPA_SUCCESS';
export const FETCH_ANTICIPA_FAILURE = 'FETCH_ANTICIPA_FAILURE';

export const FETCH_FACILITA_REQUEST = 'FETCH_FACILITA_REQUEST';
export const FETCH_FACILITA_SUCCESS = 'FETCH_FACILITA_SUCCESS';
export const FETCH_FACILITA_FAILURE = 'FETCH_FACILITA_FAILURE';

export const FETCH_SERENITA_REQUEST = 'FETCH_SERENITA_REQUEST';
export const FETCH_SERENITA_SUCCESS = 'FETCH_SERENITA_SUCCESS';
export const FETCH_SERENITA_FAILURE = 'FETCH_SERENITA_FAILURE';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const PAY_USER_INVOICE_REQUEST = 'PAY_USER_INVOICE_REQUEST';
export const PAY_USER_INVOICE_SUCCESS = 'PAY_USER_INVOICE_SUCCESS';
export const PAY_USER_INVOICE_FAILURE = 'PAY_USER_INVOICE_FAILURE';